import { defineStore } from 'pinia';
import { ref } from 'vue';

import type {
  GeofenceRuleDTO,
  NotificationGeofenceModalOpenContext,
} from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useGeofenceModalStore = defineStore('geofenceModalStore', () => {
  const isShowingGeofenceModal = ref(false);
  const currentGeofenceRule = ref<GeofenceRuleDTO>();
  const currentContext = ref<NotificationGeofenceModalOpenContext | undefined>();
  const isError = ref(false);
  const geofenceTriggerTime = ref<Date>();

  const api = useApiStore();

  async function showGeofenceModal(
    operationId: string,
    ruleId: string,
    triggerTime: Date | string,
    context?: NotificationGeofenceModalOpenContext,
  ): Promise<void> {
    isShowingGeofenceModal.value = true;
    let geofenceRuleData;

    try {
      geofenceRuleData = await api.unwrap(
        api.geofence.getOperationGeofenceRule({
          operationId,
          id: ruleId,
        }),
      );
      if (!geofenceRuleData.data) {
        throw new Error('Geofence rule data not found');
      }
    }
    catch (error) {
      console.error('Error fetching geofence rule:', error);
      isError.value = true;
      return;
    }

    currentGeofenceRule.value = geofenceRuleData.data;
    geofenceTriggerTime.value = typeof triggerTime === 'string' ? new Date(triggerTime) : triggerTime;
    currentContext.value = context;
  }

  const closeModal = (): void => {
    isShowingGeofenceModal.value = false;
    isError.value = false;
    currentGeofenceRule.value = undefined;
    currentContext.value = undefined;
  };

  return {
    currentGeofenceRule,
    geofenceTriggerTime,
    currentContext,
    isShowingGeofenceModal,
    isError,
    showGeofenceModal,
    closeModal,
  };
});
